import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface Tab {
  key: string
  labelKey: string
  fallback: string
  disabled?: boolean
}

const TABS: Tab[] = [
  { key: 'identity', labelKey: 'student.identity.tab', fallback: 'Identité' },
  { key: 'calendar', labelKey: 'student.calendar.tab', fallback: 'Calendrier' },
  { key: 'schedule', labelKey: 'student.schedule.tab', fallback: 'Emploi du temps' },
  { key: 'activities', labelKey: 'student.activities.tab', fallback: 'Activités' },
  { key: 'planning', labelKey: 'student.planning.tab', fallback: 'Planning' },
]

interface EtudiantTabsProps {
  activeTab: string
  onTabChange: (key: string) => void
  calendarLabel?: string
}

export function EtudiantTabs({ activeTab, onTabChange, calendarLabel }: EtudiantTabsProps) {
  const { t } = useTranslation()

  return (
    <div className="mb-8 border-b border-neutral-200">
      <nav className="-mb-px flex">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key
          const label =
            tab.key === 'calendar' && calendarLabel
              ? calendarLabel
              : t(tab.labelKey, tab.fallback)
          return (
            <button
              key={tab.key}
              type="button"
              disabled={tab.disabled}
              onClick={() => !tab.disabled && onTabChange(tab.key)}
              className={cn(
                'flex-1 py-4 text-center text-sm font-semibold uppercase tracking-wide transition-colors',
                isActive
                  ? 'border-b-[3px] border-primary text-primary'
                  : 'text-neutral-400 hover:text-neutral-600',
                tab.disabled && 'cursor-not-allowed opacity-40 hover:text-neutral-400',
              )}
            >
              {label}
            </button>
          )
        })}
      </nav>
    </div>
  )
}
